import { render, staticRenderFns } from "./NewYearBaydin.vue?vue&type=template&id=99523c4e&scoped=true&"
import script from "./NewYearBaydin.vue?vue&type=script&lang=js&"
export * from "./NewYearBaydin.vue?vue&type=script&lang=js&"
import style0 from "./NewYearBaydin.vue?vue&type=style&index=0&id=99523c4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99523c4e",
  null
  
)

export default component.exports